// Simple JS module (no TypeScript)

import axios from "axios";


import {API_URL, setDefaultHeaderApi} from "../../Redux/variables";

const client = axios.create({
    baseURL: API_URL || "https://nabadmin.propmax.ai/api/",
    timeout: 15000,
});

try {
    if (typeof setDefaultHeaderApi === "function") setDefaultHeaderApi();
} catch { /* noop */
}


const pickArray = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (payload?.data && Array.isArray(payload.data)) return payload.data;
    if (payload?.data?.data && Array.isArray(payload.data.data)) return payload.data.data;
    return [];
};

export const fetchSocieties = async (page = 1, search = "", authority = 'all') => {
    try {
        const params = {page};
        if (search) {
            params.search = search;
        }
        if (authority !== 'all') {
            params.authority = authority;
        }

        const res = await client.get("/societies", {params});
       // console.log(res.data,'res');
        return {
            data: pickArray(res.data),
            societies:res.data.societies,
            meta: res.data?.meta || null
        };
    } catch (err) {
        console.error("fetchSocieties error:", err);
        return {data: [], meta: null};
    }
};


export const searchSocieties = async (query, authority) => {
    if (!query?.trim()) return [];
    try {
        let params = {};
        if (authority !== 'all') {
            params = {
                search: query.trim(),
                authority
            }
        } else {
            params = {search: query.trim()};
        }
        const res = await client.get("/societies", {
            params,
        });
        return pickArray(res.data);
    } catch (err) {
        console.error("searchSocieties error:", err);
        return []; // ✅ no mock fallback
    }
};

